import {
  MaterialFactCheckIcon,
  MaterialFormatListBulletedFillIcon,
  MaterialTextSnippetIcon,
} from '@gohighlevel/ghl-icons/24/material/rounded'
import { BrowserIcon, Certificate01Icon, Headphones01Icon, VideoRecorderIcon } from '@gohighlevel/ghl-icons/24/outline'

import { PostContentType } from './enums'

export const getPostContentTypeIcon = (contentType?: string | null, isCertificate = false) => {
  if (isCertificate) {
    return Certificate01Icon
  }

  switch (contentType) {
    case PostContentType.video:
      return VideoRecorderIcon
    case PostContentType.audio:
      return Headphones01Icon
    case PostContentType.embed:
      return VideoRecorderIcon
    case PostContentType.assignment:
      return MaterialFactCheckIcon
    case PostContentType.quiz:
      return MaterialFormatListBulletedFillIcon
    case PostContentType.funnel:
      return BrowserIcon
    default:
      return MaterialTextSnippetIcon
  }
}
